import React from "react";
import { Persona } from "@soulmachines/smwebsdk";
import Slider from "react-slick";

import { isMobileOnly } from "react-device-detect";
import { TipsTypes } from "../../../types/ContentCard";
import { TipsContainer } from "./TipsStyles";

import Continue from "../../../assets/Images/Mobile/Continue.png";
import LeftArrow from "../../../assets/Images/Desktop/LeftArrow.png";
import RightArrow from "../../../assets/Images/Desktop/RightArrow.png";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CustomLeftArrow = (props: any) => {
  const { className, onClick } = props;
  return (
    <img
      className="custom-left-arrow"
      src={LeftArrow}
      onClick={() => {
        if (!className.includes("disabled")) {
          onClick();
        }
      }}
    />
  );
};
const CustomRightArrow = (props: any) => {
  const { className, onClick } = props;
  return (
    <img
      className="custom-right-arrow"
      src={RightArrow}
      onClick={() => {
        if (!className.includes("disabled")) {
          onClick();
        }
      }}
    />
  );
};

const Tips: React.FC<{
  contentCardData: TipsTypes;
  tabletLandscape: boolean;
  persona: Persona;
  dispatch: Function;
  active: boolean;
}> = ({ contentCardData, tabletLandscape, persona, dispatch, active }) => {
  const renderTipText = (tipsItem: any, i: number) => {
    if (tipsItem.bulletText) {
      return (
        <div className="bullet-cards" key={i}>
          <p id="text-header">{tipsItem.text}</p>
          <ul>
            {tipsItem.bulletText.map((bullet: string, i: number) => {
              return <li key={i}>{bullet}</li>;
            })}
          </ul>
        </div>
      );
    }

    return (
      <div className="cards" key={i}>
        {tipsItem.textHeader && <p id="text-header">{tipsItem.textHeader}</p>}
        <p>
          {tipsItem.text}
          {tipsItem.link && (
            <a href={tipsItem.link} target="_blank">
              {tipsItem.linkText}
            </a>
          )}
        </p>
      </div>
    );
  };

  return (
    <TipsContainer
      data-sm-content="tips"
      style={{
        position: "relative",
      }}
    >
      <p id="tips-header">{contentCardData.data.subHeader}</p>

      <Slider
        variableWidth={true}
        infinite={false}
        slidesToScroll={1}
        slidesToShow={1}
        centerMode={isMobileOnly ? true : false}
        dots={contentCardData.data.tips.length === 0 ? false : true}
        arrows={
          isMobileOnly || contentCardData.data.tips.length === 0 ? false : true
        }
        swipeToSlide={true}
        prevArrow={<CustomLeftArrow />}
        nextArrow={<CustomRightArrow />}
        dotsClass="button__bar"
      >
        {contentCardData.data.tips.map((tip, i) => {
          return renderTipText(tip, i);
        })}
      </Slider>

      <button
        className="continue"
        disabled={!active}
        onClick={() => {
          persona.conversationSend("Continue", {}, {});
          dispatch({
            type: "ADD_CONVERSATION_MESSAGE",
            payload: {
              source: "user",
              text: "Continue",
            },
          });
        }}
      >
        Click or say “continue” <img src={Continue} alt="Continue" />
      </button>
    </TipsContainer>
  );
};

export default Tips;
